import {connect} from 'react-redux';
import ButtonTabuYashirServerRequest from './ButtonTabuYashirServerRequest';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getNesachTabu} from 'modules/Inspection/actions/steps/getNesachTabu';

export default connect(
  null,
  {showGlobalErrorMessage, getNesachTabu}
)(ButtonTabuYashirServerRequest);
